import React, { useEffect, useState } from 'react';
import { useNavigate, useSearchParams } from 'react-router-dom';
import { API_BASE_URL } from '../../config/api';

const SsoCallback: React.FC = () => {
  const navigate = useNavigate();
  const [searchParams] = useSearchParams();
  const [error, setError] = useState<string | null>(null);

  useEffect(() => {
    const controller = new AbortController();

    const processCallback = async () => {
      const token = searchParams.get('token');
      const errorParam = searchParams.get('error');

      if (errorParam) {
        navigate('/login?error=' + errorParam, { replace: true });
        return;
      }

      if (!token) {
        navigate('/login?error=sso_error', { replace: true });
        return;
      }

      try {
        // Store the token
        localStorage.setItem('token', token);

        // Fetch user profile with the token
        const response = await fetch(`${API_BASE_URL}/profile`, {
          method: 'GET',
          headers: {
            'Authorization': `Bearer ${token}`,
            'Accept': 'application/json',
          },
          signal: controller.signal,
        });

        if (response.ok) {
          const data = await response.json();
          const user = data.user || data;
          localStorage.setItem('user', JSON.stringify(user));

          // Check if there's a pending signing redirect
          const signingToken = sessionStorage.getItem('signing_redirect_token');
          if (signingToken) {
            sessionStorage.removeItem('signing_redirect_token');
            window.location.href = window.location.origin + '/sign/' + signingToken;
          } else {
            window.location.href = window.location.origin + '/';
          }
        } else {
          localStorage.removeItem('token');
          navigate('/login?error=sso_error', { replace: true });
        }
      } catch (err) {
        // Ignore aborts from React StrictMode cleanup or page navigation
        if (controller.signal.aborted) return;
        console.error('SSO callback error:', err);
        localStorage.removeItem('token');
        navigate('/login?error=sso_error', { replace: true });
      }
    };

    processCallback();

    return () => controller.abort();
  }, [searchParams, navigate]);

  return (
    <div className="min-h-screen flex items-center justify-center">
      {error ? (
        <div className="text-red-600">{error}</div>
      ) : (
        <div className="flex items-center gap-3">
          <div className="animate-spin h-6 w-6 border-4 border-primary rounded-full border-t-transparent"></div>
          <span className="text-muted-foreground">Completing sign in...</span>
        </div>
      )}
    </div>
  );
};

export default SsoCallback;
